import React from 'react';
import { PartnerDisplayRole } from '../../hooks/usePartnerRoles';

export type RoleTagSize = 'sm' | 'lg';

// Label + CSS variant per role. Admin/Viewer are Partner-facing; AceUp
// Admin/Viewer are AceUp staff. Styling lives in styles/role_tag.css.
const ROLE_TAG: Record<PartnerDisplayRole, { label: string; variant: string }> = {
  PartnerAdmin: { label: 'Admin', variant: 'admin' },
  PartnerViewer: { label: 'Viewer', variant: 'viewer' },
  AceUpAdmin: { label: 'AceUp Admin', variant: 'aceup-admin' },
  AceUpViewer: { label: 'AceUp Viewer', variant: 'aceup-viewer' },
};

interface RoleTagProps {
  // Named `displayRole` (not `role`) to avoid colliding with the ARIA `role`
  // attribute, which the jsx-a11y lint rule validates against.
  displayRole: PartnerDisplayRole;
  /** `sm` for navigation (default), `lg` for the account page. */
  size?: RoleTagSize;
  className?: string;
}

const RoleTag: React.FC<RoleTagProps> = ({ displayRole, size = 'sm', className = '' }) => {
  const { label, variant } = ROLE_TAG[displayRole];
  return (
    <span className={`au-role-tag au-role-tag-${size} au-role-tag-${variant} ${className}`.trim()}>
      {label}
    </span>
  );
};

export default RoleTag;
